import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SectionText from './SectionText';
import SectionParallax from './SectionParallax';
import {getBowserState} from '@epic-core/common';
import debounce from 'lodash.debounce';
import root from 'window-or-global';
import {getOptImage} from 'epic-ue-shared';

export default class Section extends Component {
    constructor(props) {
        super(props);

        const sectionClick = (event) => {
            const {slideCount, id, slideOpen, sectionClickCheck} = this.props;

            if (slideCount === 1) {
                return;
            }

            if (slideOpen && id !== slideOpen) {
                return;
            }

            if (sectionClickCheck && typeof sectionClickCheck === 'function') {
                const shouldReturn = sectionClickCheck();
                if (shouldReturn) {
                    return;
                }
            }

            const {mobile} = getBowserState();

            if (!this.state.clicked) {
                this.setState({
                    clicked: true
                });

                if (event && !mobile && this.props.bkWidth > 1026) {
                    const sectionWrapper = this.wrapper;
                    if (sectionWrapper) {
                        TweenMax.to(sectionWrapper, 0.1, {
                            autoAlpha: 0,
                            onComplete: this.toggleSectionText
                        });
                    }
                }
            }
        };

        this.debounceSectionClick = debounce(sectionClick, 100, {leading: false});
    }
    static propTypes = {
        content: PropTypes.object,
        width: PropTypes.number,
        funct: PropTypes.func,
        id: PropTypes.number,
        noneOpen: PropTypes.bool,
        isSlideOpen: PropTypes.bool,
        slideOpen: PropTypes.number,
        bkWidth: PropTypes.number,
        slideCount: PropTypes.number,
        sectionClickCheck: PropTypes.func
    };

    state = {
        clicked: false,
        didLoad: false
    };

    image = {};

    toggleSectionText = () => {
        let {id} = this.props;
        const {funct, isSlideOpen} = this.props;
        const sectionWrapper = this.wrapper;
        if (isSlideOpen) {
            id = null;
        }

        if (typeof funct === 'function') {
            funct(id, false);
        }

        TweenMax.fromTo(
            sectionWrapper,
            0.5,
            {autoAlpha: 0, y: 50, delay: 0.2},
            {
                autoAlpha: 1,
                y: 0,
                delay: 0.5,
                clearProps: 'all',
                onComplete: this.toggleFinished
            },
            0.5
        );
    };

    toggleFinished = () => {
        this.setState({
            clicked: false
        });
    };

    onLoad = () => {
        this.setState({
            didLoad: true
        });
    };

    UNSAFE_componentWillMount() {
        this.checkLoad(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.checkLoad(nextProps);
    }

    checkLoad(props) {
        if (root.document) {
            const content = props.content || {};
            const background = content.background || {};
            const contentArray = background.content || [];
            const bkgrImg = contentArray[0];
            if (bkgrImg) {
                this.image = root.document.createElement('img');
                this.image.src = bkgrImg;
                this.image.onload = this.onLoad;
            }
        }
    }

    render() {
        const {width, id, isSlideOpen, noneOpen, bkWidth} = this.props;
        const content = this.props.content || {};
        const background = content.background || {};
        const contentArray = background.content || [];
        let bkgrImg = contentArray[0];
        let sectionBkgrd = '';
        const {mobile, tablet} = getBowserState();
        const bkgrdType = background.type;
        const {didLoad} = this.state;
        const sectStyle = {width: `${width}px`, left: `${width * id}px`};
        const sectClass = classNames('section', {
            loaded: didLoad,
            expand: isSlideOpen,
            notexpanded: !isSlideOpen,
            shrink: !isSlideOpen && !noneOpen,
            hover: !isSlideOpen && this.props.slideCount > 1
        });

        // Set image based on device or image aspect ratio
        if (tablet || bkWidth < 1025) {
            bkgrImg = background.tabletImage || bkgrImg;
        } else if (mobile || bkWidth < 450) {
            bkgrImg = background.mobileImage || background.tabletImage || bkgrImg;
        }

        const bkgrdStyle = {
            width: `${bkWidth}px`,
            backgroundImage: `url(${getOptImage({url: bkgrImg, width: 1920})})`
        };

        // determine type
        if (bkgrdType === 'image') {
            sectionBkgrd = <div className="bkgrd" style={bkgrdStyle} />;
        } else if (bkgrdType === 'parallax') {
            sectionBkgrd = <SectionParallax images={contentArray} range={15} />;
        }

        if (!sectionBkgrd) {
            console.warn(this.props);
        }

        return (
            <div
                id={id}
                ref={(c) => {
                    this.section = c;
                }}
                role="presentation"
                className={sectClass}
                onClick={this.debounceSectionClick}
                onTouchEnd={this.debounceSectionClick}
                style={sectStyle}>
                {sectionBkgrd}
                <div className="closeButton">
                    <i className="icon-cross" />
                </div>

                <div
                    className="content"
                    ref={(c) => {
                        this.wrapper = c;
                    }}>
                    <SectionText
                        text={content.title}
                        bkWidth={bkWidth}
                        animate={this.state.clicked}
                        className="h1"
                    />
                    {/*<SectionText text={content.subTitle} bkWidth={bkWidth} animate={this.state.clicked} className="h2" /> */}
                    <a href={content.btnLink} className="btn btn-primary btn-lg">
                        {content.btnLabel}
                    </a>
                </div>
            </div>
        );
    }
}
